/* firebase/index.js
exports various higher-order components and contexts
that deal with firebase
*/
import FirebaseContext, {withFirebase} from './context';
import Firebase from './firebase';

export default Firebase;
export { FirebaseContext, withFirebase };
